import React from 'react'
import './Facts.scss'

export default ({facts}) => {
	return(
		<div className="Facts">
			<ul>
				{
					facts.map((fact, i) =>
						<li key={i}>
							<p className="fact-title" dangerouslySetInnerHTML={{__html: fact.title}} />
							<p dangerouslySetInnerHTML={{__html: fact.text}} />
						</li>
					)
				}
			</ul>
		</div>
	)
}